module.exports = __webpack_public_path__ + "static/media/check_icon.9f1cac60.svg";